module.exports = __webpack_public_path__ + "static/media/BasicBoard.412d9fda.logo";